export const createModel = () => {
  let id = 0;

  const regions = [];

  return {
    // nodes defined in annotation (layer) XML from DataServer - note that I am retaining the exact XML node names as my var names
    Name: undefined,
    get Id () {
      return id;
    },
    set Id (value) {
      const tmp = Number(value);
      if (isNaN(tmp)) {
        throw new Error(`LayerModel:setId -> ${value} is not a number.`);
      }
      id = tmp;
    },

    ReadOnly: false, // not implemented!
    NameReadOnly: false, // not implemented!
    LineColorReadOnly: false, // not implemented!
    Incremental: true, // note: it is unclear why the layer is carrying the macro's incremental status.  Presumably imagescope needs it
    Selected: false,
    isVisible: true,

    Type: undefined,
    InputAnnotationId: undefined,
    MacroName: undefined,
    MacroId: undefined,

    LineColor: undefined, // color in BGR

    // derived information
    isSupported: true, // see us.anLayerTypesSupported
    typeName: undefined, // string of layer type
    isReportLayer: false, // TODO: Since this is subclassed now, remove
    isAnnotLayer: false, // TODO: Since this is subclassed now, remove
    get nRegions () { // is this used?
      return regions.length;
    },

    // TODO: What are these? The original code says they're for analysis, but also seem to reference them for reports?
    attributes: [],

    regions
  };
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/model.js